// src/utils/scroll.js
import Lenis from "@studio-freight/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function initSmoothScroll() {
  const lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
    smoothTouch: false,

    // ✅ IMPORTANT: allow native scrolling inside these elements
    prevent: (node) =>
      node?.closest?.(
        ".chat-window, .modal, .modal-content, .modal-overlay, .modal-panel, .modal-body, [data-lenis-prevent]"
      ),
  });

  // ✅ keep ScrollTrigger synced with Lenis
  lenis.on("scroll", ScrollTrigger.update);

  // ✅ Use requestAnimationFrame loop
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // ✅ use documentElement as scroller source
  const scroller = document.documentElement;
  ScrollTrigger.defaults({ scroller });

  ScrollTrigger.scrollerProxy(scroller, {
    scrollTop(value) {
      if (arguments.length) {
        lenis.scrollTo(value, { immediate: true });
      }
      return window.scrollY || window.pageYOffset;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
  });

  // ✅ refresh triggers after everything stabilizes
  const refresh = () => ScrollTrigger.refresh();
  window.addEventListener("load", refresh);

  // also refresh shortly after mount (fonts/images/layout settle)
  setTimeout(refresh, 0);
  setTimeout(refresh, 250);

  return lenis;
}
